import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/accessibility/updateRequest.ts
import { Exception } from "@wbk/logger";
var updateAccessibilityRequest = (_0) => __async(null, [_0], function* ({ id, body }) {
  try {
    const data = yield fetchClient({
      url: `/accessibility-profile/${id}`,
      formData: true,
      options: {
        method: "POST",
        body
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "updateAccessibilityRequestException"
    });
  }
});

export {
  updateAccessibilityRequest
};
//# sourceMappingURL=chunk-2I7HZRP4.mjs.map